import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const navItems = [
  { id: 'inicio', label: 'Inicio' },
  { id: 'como-funciona', label: 'Cómo Funciona' },
  { id: 'por-que-elegirnos', label: 'Por Qué Elegirnos' },
  { id: 'testimonios', label: 'Testimonios' },
  { id: 'preguntas-frecuentes', label: 'Preguntas Frecuentes' },
];

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('inicio');

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    const handleSectionChange = (event) => {
      setActiveSection(event.detail);
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('sectionChange', handleSectionChange);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('sectionChange', handleSectionChange);
    };
  }, []);

  const scrollTo = (id) => {
    const element = document.getElementById(id);
    const headerOffset = 80;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
    
    setIsMenuOpen(false);
  };

  return (
    <header className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'py-2' : 'py-4'} mt-4 px-2 md:px-0`}>
      <nav 
        className={`
          container mx-auto px-4 bg-white/90 backdrop-blur-md shadow-lg transition-all duration-300 
          ${isScrolled ? 'max-w-6xl' : 'max-w-7xl'}
          rounded-2xl overflow-hidden border border-white/20
        `}
      >
        <div className="flex justify-between items-center py-3">
          <button 
            onClick={() => scrollTo('inicio')}
            className="flex items-center focus:outline-none"
          >
            <img 
              src={process.env.PUBLIC_URL + '/images/favicon_catalizador.png'} 
              alt="Logo" 
              className="h-10 w-10 mr-2 rounded-full shadow-md transform hover:scale-105 transition-transform duration-300" 
            />
            <span className="font-bold bg-gradient-to-r from-blue-600 to-blue-400 bg-clip-text text-transparent text-lg">
              VendeTuCatalizador.com.mx
            </span>
          </button>
          
          {/* Desktop Menu */}
          <ul className="hidden md:flex space-x-8">
            {navItems.map((item) => (
              <li key={item.id}>
                <button
                  onClick={() => scrollTo(item.id)}
                  className={`relative hover:text-blue-500 transition-colors group ${
                    activeSection === item.id ? 'font-bold text-blue-600' : 'text-gray-600'
                  }`}
                >
                  {item.label}
                  <span className={`absolute -bottom-1 left-0 h-0.5 bg-blue-500 transition-all duration-300 ${
                    activeSection === item.id ? 'w-full' : 'w-0 group-hover:w-full'
                  }`}></span>
                </button>
              </li>
            ))}
          </ul>
          
          {/* Mobile Menu Button */}
          <button 
            className="md:hidden text-blue-600 hover:text-blue-400 transition-colors duration-300"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
        
        {/* Mobile Menu */}
        <div 
          className={`
            md:hidden transition-all duration-300 ease-in-out
            ${isMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}
          `}
        >
          <ul className="py-4">
            {navItems.map((item) => (
              <li key={item.id} className="mb-2">
                <button
                  onClick={() => scrollTo(item.id)}
                  className={`w-full text-left py-2 px-4 rounded hover:bg-blue-50 transition-all duration-300 transform hover:translate-x-2 ${
                    activeSection === item.id ? 'font-bold text-blue-600 bg-blue-50' : 'text-gray-600'
                  }`}
                >
                  {item.label}
                </button>
              </li>
            ))}
            {/* Static CTA Button */}
            <li className="mb-2 mt-4">
              <a
                href="https://cotizador.vendetucatalizador.com.mx"
                className="w-full flex justify-center bg-gradient-to-r from-blue-600 to-blue-500 text-white py-3 px-8 rounded-full text-lg font-semibold hover:from-blue-500 hover:to-blue-400 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
              >
                Obtén tu Cotización Ahora
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
};

export default Header;
